import { node, shape } from "prop-types";
import React, { createContext } from "react";
import { Row } from "react-bootstrap";

export const EcheqTransactionContext = createContext({});
const { Provider } = EcheqTransactionContext;
export const EcheqTransaction = ({ children, transaction }) => (
    <Provider value={{ transaction }}>
        <div className="container transaction-ticket">
            <Row>{children}</Row>
        </div>
    </Provider>
);

EcheqTransaction.propTypes = {
    children: node.isRequired,
    transaction: shape({}).isRequired,
};
